import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { DrivingExemptionAudit, DrivingExemptionStatusEnum, UserDrivingExemptionList } from "../../../shared/models/api/models";
import { formatDateTime } from "../../../shared/models/mapping/mapping";
import DrivingExemptionPage from "./DrivingExemptionPage";
import { gnhUserDetails } from "./DrivingExemptionPageSelector";
import {
    Add as AddIcon,
    Remove as RemoveIcon
} from '@mui/icons-material';
import { drivingExemptionDetailsPathRoute, drivingExemptionOverviewPathRoute, gnhUsersSubmittedFormListRoute } from "./DrivingExemptionRoutes";
import { Button } from "reactstrap";
import { ExemptionFormTypeEnum } from "../../../shared/enums/exemption-form-type-enum";

interface TabHeaderProps {
    label: string,
    tabValue: string,
    activeTab: string,
    onClick: any,
    children?: React.ReactNode
}

const TabHeader = (props: TabHeaderProps) => {
    const isTabExpanded = () => {
        return props.activeTab === props.tabValue;
    }
    const tabExpanded = isTabExpanded();

    return (
        <>
            <div className="fa-details-tab-header" onClick={() => props.onClick(props.tabValue)}>
                {props.label}
                <div className="fa-details-tab-header-icon">
                    {tabExpanded ?
                        <RemoveIcon />
                        :
                        <AddIcon />
                    }
                </div>

            </div>
            <div className={`fa-details-tab-content${tabExpanded ? "" : " d-none"}`}>
                {props.children}
            </div>
        </>
    );
}
export const Tabs = {
    details: 'details',
    audit: 'audit'
}
export const DrivingExemptionStatusEnumToString = ((option: DrivingExemptionStatusEnum) => {
    switch (option) {
        case DrivingExemptionStatusEnum.Requested:
            return 'Submitted';
        case DrivingExemptionStatusEnum.InitialReviewApproved:
            return 'Endorsed';
        case DrivingExemptionStatusEnum.DeptManagerApproved:
            return 'DM Approved';
        case DrivingExemptionStatusEnum.GMApproved:
            return 'GM Approved';
        case DrivingExemptionStatusEnum.InitialReviewRejected:
            return 'Declined';
        case DrivingExemptionStatusEnum.DeptManagerRejected:
            return 'DM Declined';
        case DrivingExemptionStatusEnum.GMRejected:
            return 'GM Declined';
        case DrivingExemptionStatusEnum.Approved:
            return 'Approved';
        case DrivingExemptionStatusEnum.Expired:
            return 'Expired';
        case DrivingExemptionStatusEnum.InitialReviewCancelled:
            return 'Initial Review Incompleted';
        case DrivingExemptionStatusEnum.FinalReviewCancelled:
            return 'Final Review Incompleted';
        default: 'NA'
    }
});
interface TabProps {
    formDetails: DrivingExemptionAudit []
}

const AuditTab = (props: TabProps) => {

    return (
        <>
            {props.formDetails.length > 0 &&
                <div className="grid-table">
                    <div className="grid-details-row grid-header">
                        <div className="grid-cell grid-header-font">Status</div>
                        <div className="grid-cell grid-header-font">Actioned By</div>
                        <div className="grid-cell grid-header-font">Updated Date</div>
                        <div className="grid-cell grid-header-font">Comments</div>
                    </div>
                    <div>
                        {
                            props.formDetails.map((auditItem) => (
                                <div key={auditItem.id} className="grid-details-row">
                                    <div className="grid-cell">{DrivingExemptionStatusEnumToString(auditItem.status)}</div>
                                    <div className="grid-cell">{auditItem.actionedBy}</div>
                                    <div className="grid-cell">{formatDateTime(auditItem.updateDate)}</div>
                                    <div className="grid-cell">{auditItem.updateComment}</div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            }
        </>
    );
}
interface DrivingExemptionDetailsProps {
    audithistory: DrivingExemptionAudit[]
}
const DrivingExemptionDetails = (props: DrivingExemptionDetailsProps) => {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(Tabs.audit);
    const [formDetails] = useState(location.state as DrivingExemptionAudit[]);
    const params = useParams() as any;
    const [selectedPage] = useState(params.dashboardType);
    const navigate = useNavigate();

    const getActionPath = (tab: string) => {
        let url = `${drivingExemptionDetailsPathRoute.path}/${tab}`;
        return url;
    }

    const tabClicked = (tab: string) => {
        if (tab === activeTab) {
            tab = '';
        }
        setActiveTab(tab);
        navigate(getActionPath(tab));
    }

    const goToDashboard = () => {
        let url = (selectedPage === "ExemptionsDashboard") ? `${drivingExemptionOverviewPathRoute.path}` : `${gnhUsersSubmittedFormListRoute.path }` ;
        navigate(url);
    }
    

    return (
        <DrivingExemptionPage selectedPage={gnhUserDetails}>
            {formDetails != undefined ?
                <>
                    <div className="fa-details-container fa-details-body">

                        <TabHeader
                            label="History"
                            onClick={tabClicked}
                            tabValue={Tabs.audit}
                            activeTab={Tabs.audit}>
                            <AuditTab formDetails={formDetails} />
                        </TabHeader>

                    </div>
                  <div className="fa-details-container fa-details-footer">
                      <Button className="btn-primary m-1" onClick={goToDashboard}>Back to dashboard</Button>
                  </div>
                </>
                :
                <div>Loading...</div>
            }
        </DrivingExemptionPage>
    );
}

export default DrivingExemptionDetails;
